import Link from "next/link";

const Success = () => {
  return(
    <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <img src="assets/success.svg" alt="success" style={{ height: '100px', margin: '20px auto' }}/> 
        <div className="fo-34 lh-34 mt-2 mb-3 fw-700 text-center mfo-24">Consultation Booked <br></br>Successfully</div>
        <div className="text-center txtco fo-20 fw-600 mfo-16">Our consultant shall reach out to you <br></br>within 48 hours to guide you!</div>
        <hr className="successhr"></hr>
        <Link href='/programs'>
          <button className="btn sendButton consultationButton successbtn">Check out our programmes</button>
        </Link>
      </div>
    </div>
  )
}

export default Success;
